export default {
  OS: "desktop",
  isDesktop: true,
};
